import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { localPersistStorage } from "~/lib/persist-storage";

type BmiStoreType = {
  bmi: string | null;
  setBmi: (bmi: string) => void;
  clearBmi: () => void;
};

const initialState = {
  bmi: null,
};

export const useBmiStore = create<BmiStoreType>()(
  persist(
    (set) => ({
      ...initialState,
      setBmi: (bmi: string) => set({ bmi }),
      clearBmi: () => set({ ...initialState }),
    }),
    {
      name: "bmi-storage",
      storage: createJSONStorage(() => localPersistStorage),
    },
  ),
);

